import SuccessPage from '@gameday/common/components/form/Common/SuccessPage'
import ResetPasswordPage from '@gameday/react-components/components/ResetPasswordPage'

import withWidth from '@material-ui/core/withWidth'
import { useEffect } from 'react'
import { resetPasswordMsgSuccess } from 'shared/copy'

import routes from '../../../../constants/routes/routes'
import { buildPath } from '../../../../utils/common'

const ResetPassword = ({
  history,
  resetPassword,
  isSubmitPending,
  resetPasswordMsg,
  resetStatus,
  setResetPasswordMsg,
  eventLogo,
  landingPageLogo,
  formType,
  width,
  urlParams,
  orgLogo,
  landingPageImage,
  bgGradientPrimaryColor,
  bgGradientSecondaryColor,
}) => {
  useEffect(() => {
    setResetPasswordMsg(undefined)
  }, [])

  const { email, token, application } = urlParams
  const isAuthorised = email && email !== '' && token && token !== '' && application && application !== ''
  return (
    <>
      {resetPasswordMsg ? (
        <SuccessPage
          history={history}
          headingMessage={resetStatus === 'error' ? 'There was a problem' : 'Password has been reset!'}
          subHeadingMessage={resetPasswordMsg}
          redirectLoginPath={buildPath(formType, routes.login.path, history, urlParams)}
          hideIcon={resetStatus === 'error'}
        />
      ) : (
        <ResetPasswordPage
          title="Reset Password"
          redirectLoginPath={buildPath(formType, routes.login.path, history, urlParams)}
          logo={formType === 'event' ? eventLogo : orgLogo || landingPageLogo}
          handleSubmit={({ password }) =>
            resetPassword({
              token,
              email,
              application,
              password: password.value,
            })
          }
          loadingUpdatePassword={isSubmitPending}
          email={email}
          authorised={isAuthorised}
          formSuccess={resetPasswordMsg === resetPasswordMsgSuccess ? resetPasswordMsg : ''}
          formError={resetPasswordMsg && resetPasswordMsg !== resetPasswordMsgSuccess ? resetPasswordMsg : ''}
          application={width !== 'xs' ? 'desktop' : 'mobile'}
          {...(landingPageImage && { backgroundImage: landingPageImage })}
          primaryColor={bgGradientPrimaryColor}
          secondaryColor={bgGradientSecondaryColor}
        />
      )}
    </>
  )
}

export default withWidth()(ResetPassword)
